import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@vr/lib';

const Label = styled.label`
  display: flex;
  align-items: center;
  input {
    display: none;
  }
  ${({ disabled }) =>
    disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;

const Field = styled.span`
  font-size: 20px;
  margin-right: 1rem;
  color: ${props =>
    props.checked ? props.theme.colors.primary : props.theme.colors.gray400};
  i {
    font-size: 25px;
  }
`;

function CheckboxWithContent({
  name,
  value,
  checked: propsChecked,
  children,
  className,
  onChange,
  disabled,
  ...rest
}) {
  const [checked, setChecked] = useState(propsChecked);

  useEffect(() => {
    setChecked(propsChecked);
  }, [propsChecked]);

  function handleOnChange(e) {
    setChecked(!checked);

    if (onChange) {
      onChange(e);
    }
  }

  return (
    <Label
      aria-label="label"
      checked={checked}
      className={className}
      id={`checkbox-${value}`}
      disabled={disabled}
    >
      <Field checked={checked}>
        {checked ? (
          <FontAwesomeIcon
            data-testid="checked-icon"
            icon={['fas', 'check-square']}
          />
        ) : (
          <FontAwesomeIcon icon={['far', 'square']} />
        )}
      </Field>
      <input
        type="checkbox"
        name={name}
        value={value}
        checked={checked}
        onChange={handleOnChange}
        className="hidden"
        disabled={disabled}
        {...rest}
      />
      {children}
    </Label>
  );
}

CheckboxWithContent.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.any]),
  className: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

CheckboxWithContent.defaultProps = {
  name: '',
  value: '',
  checked: false,
  children: null,
  className: null,
  onChange: null,
  disabled: false,
};

export default CheckboxWithContent;
